import { ComponentStyleConfig } from "@chakra-ui/react";

const InputStyles: ComponentStyleConfig = {
  variants: {
    outline: {
      field: {
        borderColor: 'compo.200',
        _hover: {
          borderColor: 'compo.300',
        },
        _focusVisible: {
          border: '1px solid var(--bMint-300)',
          boxShadow: '0 0 0 0.5px var(--bMint-300)',
        },
        _autofill: {
          transition: 'background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s',
        }
      },
    },
  },
};

export default InputStyles
